/* eslint-disable no-nested-ternary */
import React from 'react';
import { Container } from '@adobe/cq-react-editable-components';
import PropTypes from 'prop-types';
import { Col, Row } from '@vds/grids';
import styled from 'styled-components';
import { TextLink } from '@vds/buttons';
import { Line } from '@vds/lines';

import { Body } from '../../../../common/Typography/index';
import './cart.css';
import {
  isMobile,
  isMVA,
  isTablet,
  getFlowType,
  getLTEUpgrade,
  getSession,
  dayAndMonth,
  setSession,
} from '../../../../common/Helpers/index';
import { getProductRefData } from '../../../../../utils/plansReference';
import { goToProcessStep } from '../../../../../redirection';
import { SetupLearnMoreLink } from './setupLearnMoreLink';

const Spacing = styled.div`
  margin: ${({ margin }) => margin && margin.map((value) => `${value}px`).join(' ')};
`;

export default class dueToday extends Container {
  constructor(props) {
    super(props);
    this.planInfo = '';
    this.isTablet = isTablet();
    this.isMobile = isMobile();
    this.flowType = getFlowType();
    this.isMVA = isMVA();
  }

  editInstall = (selectedDate) => {
    if (selectedDate) {
      setSession('selectedDate', selectedDate);
    }
    // setSession('isEditSetupOption', true);
    goToProcessStep(this.props.currentView, this.props.history, false, false, false, true);
  };

  renderHTMLContent = (SDList, plansReferenceData, pageName, cartStateProSetup) => {
    // const fwaSWOfferApplied = this.props?.orderDetails?.fwaSWOfferApplied || false;
    const cartEligibleBundles = this.props?.orderDetails?.eligible5GHomeBundle || [];
    const proSetupStartTime = cartStateProSetup?.slotStartTime;
    const proSetupEndTime = cartStateProSetup?.slotEndTime;
    const proSetupDate = cartStateProSetup?.profInstallDate;
    this.planInfo = getProductRefData(SDList.sorId, SDList.productId, plansReferenceData);
    let planName = SDList?.name || '';
    let EUPDetails = {};
    let equipmentUpgradeTitle = '';
    let equipmentUpgradeValue = '';
    let mtnValue = '';
    if (getLTEUpgrade()) {
      EUPDetails = this.props.EUPDetails ? this.props.EUPDetails : null;
      equipmentUpgradeTitle = EUPDetails && EUPDetails.EquipmentUpgradeTitle ? EUPDetails.EquipmentUpgradeTitle : '';
      equipmentUpgradeValue = EUPDetails && EUPDetails.EquipmentUpgradeValue ? EUPDetails.EquipmentUpgradeValue : '';
      mtnValue = EUPDetails && EUPDetails.MTNValue ? EUPDetails.MTNValue : '';
    }
    if (SDList?.name) {
      planName = SDList.name;
    } else if (this.planInfo && this.planInfo.length > 0) {
      if (this.flowType === 'LTE') {
        planName = this.planInfo[0].cart_Tdy_lte;
      } else if (this.planInfo && this.planInfo.length > 0) {
        planName = this.planInfo[0].cart_Tdy_5g;
      }
    }
    let installationType;
    if (SDList.installationType) {
      // TODO : need to cleanup
      if (SDList.installationType.toLowerCase().toString().includes('prof')) {
        installationType = 'Professional Setup';
      } else if (SDList.installationType.toLowerCase().toString().includes('self')) {
        installationType = 'Self Setup';
      }
    }
    const {
      deliverBy,
      shipBy,
      learnMoreHyperlinkText,
      learnMoreOverlayTitleText,
      learnMoreOverlayBodyText,
      learnMoreProfHeaderTGW,
      learnMoreProfModalContentTGW,
      ScheduledAfterCheckoutTGW,
    } = this.props;
    let backOrderMessage = '';
    if (SDList && SDList.itemType === 'DEVICE' && SDList.isBackorder && SDList.preBackDate && SDList.installationType === 'Self SetUp') {
      if (SDList.isShipBy === 'true' || SDList.isShipBy === true) {
        backOrderMessage = shipBy;
      }
      if (SDList.isDeliverBy === 'true' || SDList.isDeliverBy === true) {
        backOrderMessage = deliverBy;
      }
    }

    const showIsLearnMore =
      !cartEligibleBundles?.length ||
      (cartEligibleBundles?.length === 1 && cartEligibleBundles[0].bundleName && cartEligibleBundles[0].bundleName.includes('Self'));

    const isDisplaySetupEdit = pageName === 'cart' && cartEligibleBundles?.length > 1;
    const isTgwFlow = getSession('isTGW');
    return (
      <>
        {SDList.itemType === 'DEVICE' && !SDList.isHomePhone && (
          <Row>
            <Col xs={12}>
              <Body size="small" color="#6F7171">
                <span className="fontWight400">Included</span>
              </Body>
              <div className="marginTop4">
                <Body size="large">
                  <span className="fontWight400">{planName}</span>
                </Body>
              </div>
              {isTgwFlow && SDList.routerName && (
                <div className="marginTop4">
                  <Body size="large">
                    <span className="fontWight400">{SDList.routerName}</span>
                  </Body>
                </div>
              )}

              {SDList.installationType !== null && (
                <div>
                  <Spacing margin={this.isMobile ? [42, 0, 0, 0] : [20, 0, 20, 0]}>
                    {!this.isMobile && <Line type="secondary" surface="light" />}
                  </Spacing>
                  {isDisplaySetupEdit && (
                    <div style={{ display: 'inline-block', float: 'right' }}>
                      <TextLink
                        type="standAlone"
                        data-track="true"
                        onClick={() => this.editInstall(proSetupDate)}
                        ariaLabel="Edit self setup options"
                        id="Install_Edit_Button"
                      >
                        Edit
                      </TextLink>
                    </div>
                  )}

                  <Body size="small" color="#6F7171" >
                    <span className="fontWight400">Setup</span>
                  </Body>

                  <Body size="large" style={{ display: 'flex', justifyContent: 'space-between' }}>
                    <div className="fontWight400 marginTop4" style={{ display: 'inline-block' }}>
                      {installationType}
                    </div>

                    {pageName === 'cart' && proSetupStartTime && proSetupEndTime && (
                      <Body primitive="span" size="medium" color="#6F7171" className="contains-PII" data-cs-mask>
                        <div className="fontWight400" style={{ display: 'inline-block' }}>
                          {dayAndMonth(proSetupDate)}
                          <br />
                          between {proSetupStartTime} and {proSetupEndTime}
                        </div>
                      </Body>
                    )}

                    {showIsLearnMore && pageName === 'cart' && (
                      <div style={{ display: 'inline-block', float: 'right' }}>
                        <SetupLearnMoreLink {...{ learnMoreHyperlinkText, learnMoreOverlayTitleText, learnMoreOverlayBodyText }} />
                      </div>
                    )}
                    {isTgwFlow && isTgwFlow === 'true' && pageName === 'cart' && (
                      <>
                        <div style={{ display: 'inline-block', float: 'right' }}>
                          <SetupLearnMoreLink {...{ learnMoreProfHeaderTGW, learnMoreProfModalContentTGW }} />
                        </div>
                        <div className="fontWight400" style={{ display: 'inline-block', float: 'left', fontSize: '0.75rem', color: '#6F7171' }}>
                          {ScheduledAfterCheckoutTGW}
                        </div>
                      </>
                    )}
                  </Body>
                </div>
              )}



              <div className={this.isMobile ? 'fontSize_2 pad05' : 'fontSize_4 pad05'}>
                {SDList &&
                  SDList.itemType === 'DEVICE' &&
                  SDList.isBackorder &&
                  SDList.preBackDate &&
                  SDList.installationType === 'Self SetUp' &&
                  `${backOrderMessage} ${SDList.preBackDate.split('/')[0]}/${SDList.preBackDate.split('/')[1]}`}
                {this.flowType === 'LTE' && SDList.itemType === 'DEVICE' && !SDList.isHomePhone
                  ? ''
                  : SDList.discountApplied && SDList.discountApplied !== '0.0' && !SDList.fullPriceDiscount && <div>Discount Applied</div>}
                {getLTEUpgrade() && equipmentUpgradeTitle !== '' && SDList.quantity && SDList.itemType === 'DEVICE' ? (
                  <div>
                    <div>{equipmentUpgradeTitle}</div>
                    <div>
                      {equipmentUpgradeValue}
                      <span className="MTNValue fontWight400">{mtnValue}</span>
                    </div>
                  </div>
                ) : (
                  ''
                )}

                {((SDList.quantity && SDList.itemType !== 'DEVICE') || (SDList.quantity && SDList.isHomePhone)) &&
                  !(
                    this.planInfo &&
                    this.planInfo.length > 0 &&
                    this.planInfo[0].cartEditBtn &&
                    pageName !== 'orderreview' &&
                    pageName !== 'revieworder' &&
                    pageName !== 'orderconfirm'
                  ) && <div>Quantity: {SDList.quantity}</div>}
              </div>
            </Col>
          </Row>
        )}
      </>
    );
  };

  render() {
    const { cartDetails, plansReferenceData, pageName, cartStateProSetup } = this.props;
    // const isTgwFlow = getSession('isTGW');
    // if (isTgwFlow) {
    //   if (cartDetails && cartDetails[1]?.bundleProductId && cartDetails[1]?.itemType === 'ACCESSORY') {
    //     if (cartDetails && cartDetails[0]?.itemType === 'DEVICE') {
    //       cartDetails[0].routerName = cartDetails[1].name;
    //       cartDetails[0].imageUrlMap = cartDetails[1].imageUrlMap;
    //     }
    //   }
    // }
    return <>{cartDetails && cartDetails.map((SDList) => this.renderHTMLContent(SDList, plansReferenceData, pageName, cartStateProSetup))}</>;
  }
}

dueToday.propTypes = {
  cartDetails: PropTypes.object,
  invokeTaggingAPI: PropTypes.func,
};
